import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const CreateEventLink = styled(Link)`
  min-width: 120px;
`;

const TargetedParty = styled.li`
  padding-bottom: 0.1rem;
  list-style: circle;
  text-decoration: underline;
`;

const HiddenDropdown = styled(Dropdown)`
  #dropdown-basic {
    background: none;
    border: none;
    color: gray;
    ::after {
      display: none;
    }
  }
`;

export { CreateEventLink, TargetedParty, HiddenDropdown };
